import baseGradesBook from 'moodleDir/procollege/lib/vue/default-block-root.vue';

export default {
    routes: [
        {
            path: '/',
            component: baseGradesBook,
            name: 'baseGradesBook'
        },
    ]
};